import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Base } from "zina-dogi-react";
import { ActivityFilter, ActivityTable } from "../components";
import * as activity from "../redux";

export const ActivityList = (props) => {

    const {
        activities,
        pagination,
        changePage,
        loading,
        extraProps,
        getActivities,
        changeFilters,
        filters
    } = props;

    useEffect(() => {
        getActivities();
    }, []);

    const baseOP = {
        className: "activity_list",
        breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "Activity Management" }],
        extraProps,
        loading
    };

    const activityTableOP = {
        list: activities,
        pagination: {
            ...pagination,
            changePage
        },
        filters
    };

    const handleFilter = (filters) => {
        changeFilters(filters);
    };

    return (
        <Base {...baseOP}>
            <ActivityFilter onSubmit={handleFilter} />
            <ActivityTable {...activityTableOP} />
        </Base>
    );
};

const mapStateToProps = store => ({
    activities: store.activity.list,
    loading: store.activity.loading,
    loaded: store.activity.loaded,
    pagination: store.activity.pagination,
    filters: store.activity.filters
});

const mapDispatchToProps = dispatch => ({
    getActivities: () => dispatch(activity.actions.getActivities()),
    changePage: page => dispatch(activity.actions.changePage(page)),
    changeFilters: filters => dispatch(activity.actions.updateFilter(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivityList);